<template>
  <div>
    <v-dialog v-model="exportDialog" persistent width="400" content-class="export-dialog">
      <v-card class="export-dialog-card">
        <v-card-title class="headline grey lighten-3 export-dialog-title">
          {{ $t('message.exportDialog.title') }}
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            {{ $t('message.exportDialog.message') }}
          </div>
          <v-progress-linear
            color="primary"
            height="6"
            indeterminate
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <span class="caption grey--text">{{ $t('message.exportDialog.dontClose') }}</span>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container fluid class="pa-0">
      <div class="search-bar">
        <v-layout row wrap>
          <v-flex xs12 sm7 md6>
            <div class="list-title">
              <h3>{{ $t('message.documents.title') }}</h3>
            </div>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex sx12 sm4 md3 px-3>
            <v-btn
              solo
              color="primary"
              :disabled="exportLoading"
              @click="getListToCSV()"
            >
              {{ $t('message.exportButton') }}
              <span class="pl-1 hidden-sm-and-down">{{ $t('message.exportButtonFull') }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <div class="search-bar">
      <v-container fluid class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3>
            <v-menu
              ref="dateCreatedIni"
              :close-on-content-click="false"
              v-model="dateCreatedIni"
              :nudge-right="40"
              :return-value.sync="search.createdAtIni"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                class="lance no-right-padding"
                slot="activator"
                :value="formatDate(search.createdAtIni)"
                :label="$t('message.documents.filters.initialRegistrationDate')"
                append-icon="event"
                readonly
              >
              </v-text-field>
              <v-date-picker
                v-model="search.createdAtIni"
                show-current
                no-title
                scrollable
                :locale="$i18n.locale || 'es'"
                :header-date-format="formatCalendarHeader"
              >
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    search.createdAtIni = null;
                    $refs.dateCreatedIni.save(search.createdAtIni);
                    searchOnTable();
                  "
                  >{{ $t('message.documents.buttons.cancel') }}</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="
                    $refs.dateCreatedIni.save(search.createdAtIni);
                    searchOnTable();
                  "
                  >{{ $t('message.documents.buttons.accept') }}</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-menu
              ref="dateCreatedFin"
              :close-on-content-click="false"
              v-model="dateCreatedFin"
              :nudge-right="40"
              :return-value.sync="search.createdAtFin"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                class="lance no-right-padding"
                slot="activator"
                :value="formatDate(search.createdAtFin)"
                :label="$t('message.documents.filters.finalRegistrationDate')"
                append-icon="event"
                readonly
              >
              </v-text-field>
              <v-date-picker
                v-model="search.createdAtFin"
                show-current
                no-title
                scrollable
                :locale="$i18n.locale || 'es'"
                :header-date-format="formatCalendarHeader"
              >
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    search.createdAtFin = null;
                    $refs.dateCreatedFin.save(search.createdAtFin);
                    searchOnTable();
                  "
                  >{{ $t('message.documents.buttons.cancel') }}</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="
                    $refs.dateCreatedFin.save(search.createdAtFin);
                    searchOnTable();
                  "
                  >{{ $t('message.documents.buttons.accept') }}</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-menu
              ref="dateDocumentIni"
              :close-on-content-click="false"
              v-model="dateDocumentIni"
              :nudge-right="40"
              :return-value.sync="search.dateIni"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                class="lance no-right-padding"
                slot="activator"
                :value="formatDate(search.dateIni)"
                :label="$t('message.documents.filters.initialDocumentDate')"
                append-icon="event"
                readonly
              >
              </v-text-field>
              <v-date-picker
                v-model="search.dateIni"
                show-current
                no-title
                scrollable
                :locale="$i18n.locale || 'es'"
                :header-date-format="formatCalendarHeader"
              >
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    search.dateIni = null;
                    $refs.dateDocumentIni.save(search.dateIni);
                    searchOnTable();
                  "
                  >{{ $t('message.documents.buttons.cancel') }}</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="
                    $refs.dateDocumentIni.save(search.dateIni);
                    searchOnTable();
                  "
                  >{{ $t('message.documents.buttons.accept') }}</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-menu
              ref="dateDocumentFin"
              :close-on-content-click="false"
              v-model="dateDocumentFin"
              :nudge-right="40"
              :return-value.sync="search.dateFin"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                class="lance no-right-padding"
                slot="activator"
                :value="formatDate(search.dateFin)"
                :label="$t('message.documents.filters.finalDocumentDate')"
                append-icon="event"
                readonly
              >
              </v-text-field>
              <v-date-picker
                v-model="search.dateFin"
                show-current
                no-title
                scrollable
                :locale="$i18n.locale || 'es'"
                :header-date-format="formatCalendarHeader"
              >
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    search.dateFin = null;
                    $refs.dateDocumentFin.save(search.dateFin);
                    searchOnTable();
                  "
                  >{{ $t('message.documents.buttons.cancel') }}</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="
                    $refs.dateDocumentFin.save(search.dateFin);
                    searchOnTable();
                  "
                  >{{ $t('message.documents.buttons.accept') }}</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-autocomplete
              ref="supplierSelect"
              class="lance supplier-select"
              v-model="search.supplier"
              :items="suppliers"
              item-text="businessName"
              :label="$t('message.documents.filters.supplier')"
              @input="searchOnTable"
              return-object
            >
              <v-list-tile
                v-if="search.supplier"
                slot="prepend-item"
                @mousedown.prevent.stop
                @click.stop.prevent="clearSupplierFilter"
              >
                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                <v-list-tile-title>{{ $t('message.documents.buttons.clear') }}</v-list-tile-title>
              </v-list-tile>
              <v-divider
                v-if="search.supplier"
                slot="prepend-item"
                class="mt-2"
              ></v-divider>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              ref="documentTypeSelect"
              class="lance"
              :items="documentTypes"
              item-text="name"
              v-model="search.documentType"
              :label="$t('message.documents.filters.documentType')"
              @input="searchOnTable"
              return-object
            >
              <v-list-tile
                v-if="search.documentType"
                slot="prepend-item"
                @click="
                  search.documentType = null;
                  $nextTick(() => {
                    if ($refs.documentTypeSelect) {
                      $refs.documentTypeSelect.isMenuActive = false;
                      $refs.documentTypeSelect.blur();
                    }
                  });
                  searchOnTable();
                "
              >
                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                <v-list-tile-title>{{ $t('message.documents.buttons.clear') }}</v-list-tile-title>
              </v-list-tile>
              <v-divider
                v-if="search.documentType"
                slot="prepend-item"
                class="mt-2"
              ></v-divider>
            </v-select>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              ref="supplierTypeSelect"
              class="lance"
              :items="supplierTypes"
              item-text="name"
              v-model="search.supplierType"
              :label="$t('message.documents.filters.supplierType')"
              @input="searchOnTable"
              return-object
            >
              <v-list-tile
                v-if="search.supplierType"
                slot="prepend-item"
                @click="
                  search.supplierType = null;
                  $nextTick(() => {
                    if ($refs.supplierTypeSelect) {
                      $refs.supplierTypeSelect.isMenuActive = false;
                      $refs.supplierTypeSelect.blur();
                    }
                  });
                  searchOnTable();
                "
              >
                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                <v-list-tile-title>{{ $t('message.documents.buttons.clear') }}</v-list-tile-title>
              </v-list-tile>
              <v-divider
                v-if="search.supplierType"
                slot="prepend-item"
                class="mt-2"
              ></v-divider>
            </v-select>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              ref="statusSelect"
              class="lance"
              :items="status"
              item-text="internalText"
              v-model="search.status"
              :label="$t('message.documents.filters.status')"
              @input="searchOnTable"
              return-object
            >
              <v-list-tile
                v-if="search.status"
                slot="prepend-item"
                @click="
                  search.status = null;
                  $nextTick(() => {
                    if ($refs.statusSelect) {
                      $refs.statusSelect.isMenuActive = false;
                      $refs.statusSelect.blur();
                    }
                  });
                  searchOnTable();
                "
              >
                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                <v-list-tile-title>{{ $t('message.documents.buttons.clear') }}</v-list-tile-title>
              </v-list-tile>
              <v-divider
                v-if="search.status"
                slot="prepend-item"
                class="mt-2"
              ></v-divider>
            </v-select>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-text-field
              class="lance"
              v-model="search.purchaseOrder"
              :label="$t('message.documents.filters.purchaseOrder')"
              @input="searchOnTable"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-text-field
              class="lance"
              v-model="search.companyCode"
              :label="$t('message.documents.filters.organizationCode')"
              @input="searchOnTable"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-text-field
              class="lance"
              v-model="search.noFactura"
              :label="$t('message.documents.filters.invoiceNo')"
              @input="searchOnTable"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-autocomplete
              ref="uuidSelect"
              class="lance supplier-select"
              v-model="search.uuid"
              :items="uuidList"
              :search-input.sync="searchUuid"
              @input="searchOnTable"
              @keyup.enter="enterListUuid"
              :no-data-text="noDataUuid"
              item-text="invoiceUUID"
              :label="$t('message.documents.filters.uuid')"
            >
              <v-list-tile
                v-if="search.uuid"
                slot="prepend-item"
                @mousedown.prevent.stop
                @click.stop.prevent="clearUuidFilter"
              >
                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                <v-list-tile-title>{{ $t('message.documents.buttons.clear') }}</v-list-tile-title>
              </v-list-tile>
              <v-divider
                v-if="search.uuid"
                slot="prepend-item"
                class="mt-2"
              ></v-divider>
            </v-autocomplete>
          </v-flex>
          <!-- <v-flex xs12 sm6 md4 lg3>
            <v-text-field
              class="lance"
              v-model="search.remission"
              label="Remisión"
              @input="searchOnTable"
            >
            </v-text-field>
          </v-flex> -->
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              class="lance d-none"
              :items="deleted"
              item-text="name"
              v-model="search.deleted"
              :label="$t('message.documents.filters.active')"
              return-object
              @change="getSuppliers()"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div class="elevation-5" style="border-radius: 18px">
      <div class="text-xs-center header-table">
        <div style="display: flex; align-items: center">
          <div class="navigation-label">
            <span>{{ $t('message.documents.pagination.itemsPerPage') }}</span>
          </div>
          <div class="pr-4 aux-responsive" style="width: 50px">
            <v-select
              class="customInput pa-0"
              v-model="pagination.rowsPerPage"
              :items="[5, 10, 20, 30]"
            ></v-select>
          </div>

          <div
            class="nav-contPag hidden-md-and-down"
            v-if="pagination.totalItems > 0"
          >
            <span v-if="pageAct === pages">
              {{ (pageAct - 1) * pagination.rowsPerPage + 1 }} -
              {{ pagination.totalItems }}
            </span>
            <span v-else>
              {{ (pageAct - 1) * pagination.rowsPerPage + 1 }} -
              {{ pageAct * pagination.rowsPerPage }}
            </span>
            <span>{{ $t('message.documents.pagination.of') }}</span>
            <span> {{ pagination.totalItems }}</span>
          </div>
          <div
            class="hidden-md-and-down"
            style="width: 145px; padding: 0px 10px"
            v-else
          >
            <span> 0 </span>
            <span>{{ $t('message.documents.pagination.of') }}</span>
            <span> {{ pagination.totalItems }}</span>
          </div>
        </div>

        <div style="display: flex; align-items: center">
          <div class="navPagOf" v-if="pagination.totalItems > 0">
            <span class="hidden-lg-and-up">{{ $t('message.documents.pagination.pageShort') }}</span>
            <span class="hidden-md-and-down">{{ $t('message.documents.pagination.page') }}</span>
            <span> {{ pageAct }} </span>
            <span>{{ $t('message.documents.pagination.of') }}</span>
            <span> {{ pages }}</span>
          </div>
          <div class="navPagOf" v-else>
            <span class="hidden-lg-and-up">{{ $t('message.documents.pagination.pageShort') }}</span>
            <span class="hidden-md-and-down">{{ $t('message.documents.pagination.page') }}</span>
            <span> 0 </span>
            <span>{{ $t('message.documents.pagination.of') }}</span>
            <span> 0 </span>
          </div>
        </div>

        <div style="min-width: 100px">
          <v-btn color="primary" class="ma-0" icon flat @click="leftArrow()">
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
          <span
            ><b>{{ pageAct }}</b></span
          >
          <v-btn color="primary" class="ma-0" icon flat @click="rightArrow()">
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </div>

        <div style="width: 80px; margin-right: 5px">
          <span>{{ $t('message.documents.buttons.goToPage') }}</span>
        </div>

        <div style="width: 70px; padding-right: 2px">
          <v-text-field
            class="customInput pa-0"
            :rules="[numberRule]"
            v-model="toPage"
            hide-details
            @keyup.enter.native="goToPage()"
          ></v-text-field>
        </div>
        <div style="width: 100px; text-align: left">
          <v-btn
            id="btnChPag"
            outlined
            small
            fab
            @click="goToPage()"
            v-bind:class="{ active: toPage > 0 && toPage <= pages }"
            >
            {{ $t('message.documents.buttons.go') }}
          </v-btn>
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :items="list"
        :loading="loading"
        :pagination.sync="pagination"
        hide-actions
        class="table-catalog adjust"
        @update:page="updatePagination"
      >
        <v-progress-linear
          slot="progress"
          color="primary"
          indeterminate
        ></v-progress-linear>
        <template
          slot="items"
          slot-scope="props"
          @click="goTo('Documentsform/' + props.item.id)"
        >
          <tr class="cursor-pointer" @click="selectRow(props.item)">
            <td class="text-xs-left">{{ props.item.invoiceNum }}</td>
            <td class="text-xs-left">{{ props.item.invoiceUUID }}</td>
            <td class="text-xs-left">
              {{ formatRegistrationDate(props.item.createdAt) }}
            </td>
            <td class="text-xs-left">
              {{ formatDate(props.item.date, true) }}
            </td>
            <td class="text-xs-left">{{ props.item.companyCode }}</td>
            <td class="text-xs-left">{{ props.item.supplierCode }}</td>
            <td class="text-xs-left">{{ props.item.supplier.businessName }}</td>
            <td class="text-xs-left">{{ getDisplayStatusForItem(props.item) }}</td>
            <td class="text-xs-left">{{ props.item.details || '-' }}</td>
            <td class="text-xs-left">{{ getPhase(props.item.phase) }}</td>
            <td class="text-xs-left">
              {{ getDocumentType(props.item.documentType) }}
            </td>
            <td class="text-xs-left">
              {{ getSupplierType(props.item.supplier.supplierType.id) }}
            </td>
            <td class="text-xs-left">{{ props.item.purchaseOrder 
              ? props.item.purchaseOrder
              : props.item.shipmentNum ? props.item.shipmentNum
                : props.item.consignmentSheetNum ? props.item.consignmentSheetNum : $t('message.documents.messages.noDocument') }}</td>
            <!-- <td class="text-xs-left">{{ props.item.remission }}</td> -->
            <td class="text-xs-left">
              {{
                props.item.commentManual
                  ? props.item.commentManual
                  : $t('message.documents.messages.noComments')
              }}
            </td>
            <td class="text-xs-left">
              {{ props.item.deleted == false ? $t('message.documents.messages.yes') : $t('message.documents.messages.no') }}
            </td>
            <td class="text-xs-left">{{ props.item.typeLoad }}</td>
            <td class="text-xs-left company-cell">
              <div class="company-cell-inner">
                <span class="company-cell-rfc">{{ props.item.clientRFC || '-' }}</span>
                <v-btn
                  fab
                  small
                  color="primary"
                  class="company-cell-btn ma-0"
                  v-if="shouldEdit(props.item, credentials)"
                  @click.stop="goTo('Documentsform/' + props.item.id)"
                >
                  <img src="@/assets/icon-editar.svg" alt="" />
                </v-btn>
              </div>
            </td>
            <td class="text-xs-left">{{ props.item.sapResponse || '-' }}</td>
            <td class="text-xs-left sap-response-details-col">{{ props.item.sapResponseDetails || '-' }}</td>
            <td class="text-xs-left">{{ props.item.accountingDocumentNumber || '' }}</td>
            <td class="text-xs-left document-no-col">{{ props.item.materialDocumentNumber || props.item.documentNo || '' }}</td>
          </tr>
        </template>
        <template slot="no-data">
          {{ $t('message.documents.messages.noRecords') }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<style scoped>
.customInput >>> .v-select__slot {
  margin-bottom: -10px;
}
.customInput >>> .v-select__slot > .v-select__selections {
  padding-left: 5px;
}
.customInput >>> .v-text-field__slot > input {
  text-align: center !important;
  min-width: 45px;
}
.navPagOf {
  width: 125px;
}
.company-cell-inner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  min-width: 0;
}
.company-cell-rfc {
  flex: 1 1 auto;
  min-width: 0;
  word-break: break-word;
}
.company-cell-btn {
  flex-shrink: 0;
}
.header-table {
  background-color: #e1ecf3;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 18px 18px 0px 0px;
  border-bottom: solid 2.7px #3a8dca;
}
.navigation-label {
  width: 160px;
  display: flex;
  align-items: center;
}
.nav-contPag {
  width: 145px;
  padding: 0px 10px;
}
.active {
  background-color: #5f9fccb4 !important;
}
@media screen and (max-width: 1264px) {
  .navPagOf {
    width: 80px;
  }
  .navigation-label {
    width: 80px;
  }
}
.search-bar .flex > button.v-btn:not(.v-btn--floating) {
  margin: 0;
  width: 100% !important;
  height: 50px !important;
  text-transform: none;
  border-radius: 100px;
  color: white;
  font-size: 16px;
}
.adjust {
  border-radius: 0px 0px 18px 18px !important;
}
.table-catalog {
  padding: 15px 30px 30px 30px;
}

.table-catalog >>> table.v-table thead th:not(:first-child):not(:last-child),
.table-catalog >>> table.v-table tbody td:not(:first-child):not(:last-child) {
  padding-left: 15px;
}

.table-catalog
  >>> table.v-table
  thead
  th:not(:nth-last-child(2)):not(:last-child),
.table-catalog
  >>> table.v-table
  tbody
  td:not(:nth-last-child(2)):not(:last-child) {
  padding-right: 15px;
}

.table-catalog >>> table.v-table thead tr th {
  font-size: 14px;
  font-weight: bold;
}

.table-catalog >>> table.v-table tbody tr td {
  font-size: 12px;
}

/* Línea vertical entre Respuesta SAP y Detalles respuesta SAP */
.table-catalog >>> table.v-table thead tr th.sap-response-details-col,
.table-catalog >>> table.v-table tbody tr td.sap-response-details-col {
  border-left: 1px solid rgba(58, 141, 202, 0.5);
}

/* Línea vertical entre Detalles respuesta SAP y Número de documento (Document No.) */
.table-catalog >>> table.v-table thead tr th.document-no-col,
.table-catalog >>> table.v-table tbody tr td.document-no-col {
  border-left: 1px solid rgba(58, 141, 202, 0.5);
}
</style>

<style>
.supplier-select .v-input__control .v-input__slot .v-select__slot {
  height: 50px !important;
}

.export-dialog {
  border-radius: 12px;
}

.export-dialog-card {
  border-radius: 12px !important;
}

.export-dialog-title {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
</style>

<script>
import { events, printList } from "../main";
import xlsx from "xlsx";
import _ from "underscore";
import moment from "moment-timezone";
import filterMethod from "../utils/filterMethods";

export default {
  mixins: [filterMethod],
  components: {},
  data() {
    // Get current locale from i18n (will be set in mounted)
    const currentLocale = 'es'; // Default, will be updated in mounted
    
    return {
      currentLocale: currentLocale,
      list: [],
      source: [],
      suppliers: [],
      supplierTypes: [],
      uuidList: [],
      documentTypes: [],
      deletedOld: 0,
      deleted: [],
      pageAct: 1,
      StoredPageAct: 1,
      toPage: null,
      isSearchC: false,
      isSearchP: false,
      status: [],
      dateCreatedIni: false,
      dateCreatedFin: false,
      dateDocumentIni: false,
      dateDocumentFin: false,
      search: {
        createdAtIni: null,
        createdAtFin: null,
        dateIni: null,
        dateFin: null,
        supplier: null,
        documentType: null,
        supplierType: null,
        deleted: 0,
        status: null,
        noFactura: null,
        purchaseOrder: "",
        rowsPP: 10,
        currentPage: 2,
        sortBy: null,
        descending: null,
        uuid: null,
        remission: null,
      },
      showFilters: false,
      headers: [],
      pagination: {
        rowsPerPage: 5,
      },
      loading: true,
      uuidLoading: false,
      uuidQuerry: "",
      credentials: JSON.parse(localStorage.getItem("userCredentials")),
      numberRule: (v) => {
        if (v != undefined) {
          if (!v.trim()) return true;
          if (!isNaN(parseFloat(v)) && v > 0 && v <= this.pages) return true;
        }
        return "false";
      },
      emptyArray: [],
      nullArray: [{ invoiceUUID: "NULL" }],
      exportLoading: false,
      exportDialog: false,
    };
  },
  methods: {
    closeSelectMenu(refName) {
      this.$nextTick(() => {
        const selectRef = this.$refs[refName];
        if (selectRef) {
          selectRef.isMenuActive = false;
          selectRef.blur();
        }
      });
    },
    clearSupplierFilter() {
      this.search.supplier = null;
      this.closeSelectMenu("supplierSelect");
      this.searchOnTable();
    },
    clearUuidFilter() {
      this.uuidQuerry = "";
      this.search.uuid = null;
      this.uuidList = [];
      this.closeSelectMenu("uuidSelect");
      this.searchOnTable();
    },
    selectRow(item) {
      this.credentials.DocumentsRead
        ? this.goTo("Documentsdetail/" + item.id)
        : null;
    },
    leftArrow() {
      if (this.pageAct > 1) {
        this.pageAct--;
        localStorage.pageAct = this.pageAct;
        this.StoredPageAct = localStorage.pageAct;
      }
    },
    rightArrow() {
      if (this.pageAct < this.pages) {
        this.pageAct++;
        localStorage.pageAct = this.pageAct;
        this.StoredPageAct = localStorage.pageAct;
      }
    },
    goToPage() {
      if (this.toPage) {
        if (this.toPage > 0 && this.toPage <= this.pages) {
          this.pageAct = Number(this.toPage);

          this.search.currentPage = Number(this.toPage);
        } else this.snackbar(this.$t('message.errors.invalidPageNumber'));
      }
    },
    snackbar: function (message) {
      events.$emit("snackbar", message);
    },
    goTo(url) {
      var self = this;
      self.$router.push("/" + url);
    },
    formatCalendarHeader(val) {
      return moment(val).locale("es").format("MMMM YYYY");
    },
    formatRegistrationDate(date) {
      if (!date) return "";
      const mdate = moment(date).tz("America/Mexico_City");
      let ndate = mdate.locale("es-mx").format("DD/MMM/YYYY");
      const mes = ndate.split("/")[1];
      const nmes = mes.charAt(0).toUpperCase() + mes.slice(1, -1);
      return ndate.replace(mes, nmes);
    },
    formatDate(date, withUtc = false) {
      if (date) {
        let mdate = moment(date);
        if (withUtc) mdate = mdate.utc();
        var ndate = mdate.locale("es-mx").format("DD/MMM/YYYY");
        var mes = ndate.split("/")[1];
        var nmes = mes.charAt(0).toUpperCase() + mes.slice(1, -1);
        return ndate.replace(mes, nmes);
      }
      return "";
    },
    formatTime(date) {
      return date ? moment(date).locale("es").format("HH:mm:ss a") : "";
    },
    getStatus(value) {
      let s = this.status.find((x) => x.id == value);
      if (!s) return "";
      const currentLocale = this.$i18n.locale || 'es';
      if (currentLocale === 'en' && s.englishText) {
        return s.englishText;
      } else if (currentLocale === 'es' && s.spanishText) {
        return s.spanishText;
      }
      return s.internalText || "";
    },
    matchesInvoiceAlreadyRegisteredDetails(details) {
      const d = String(details || '').toLowerCase();
      return d.includes('invoice already registered or received');
    },
    getDisplayStatusForItem(item) {
      if (this.matchesInvoiceAlreadyRegisteredDetails(item.details)) {
        const success = this.status.find(
          (x) => x.internalId === 1 && x.documentType === 'Factura'
        );
        if (success) {
          return this.getStatus(success.id);
        }
        return 'Factura procede correctamente';
      }
      return this.getStatus(item.status);
    },
    isStatusNotFinal(i) {
      let status = this.status.find((x) => x.id == i);
      return status ? status.type != "Final" : false;
    },
    getDocumentType(value) {
      let t = this.documentTypes.find((x) => x.value == value);
      return t ? t.name : "";
    },
    updateHeadersLanguage() {
      this.headers = [
        { text: this.$t('message.documents.headers.invoiceNo'), value: "invoiceNum" },
        { text: this.$t('message.documents.headers.uuid'), value: "invoiceUUID" },
        { text: this.$t('message.documents.headers.registrationDate'), value: "createdAt" },
        { text: this.$t('message.documents.headers.documentDate'), value: "date" },
        { text: this.$t('message.documents.headers.organizationCode'), value: "companyCode" },
        { text: this.$t('message.documents.headers.supplierNo'), value: "supplierCode" },
        { text: this.$t('message.documents.headers.supplier'), value: "supplier.businessName" },
        { text: this.$t('message.documents.headers.status'), value: "status", width: 200 },
        { text: this.$t('message.documents.headers.details'), value: "details" },
        { text: this.$t('message.documents.headers.phase'), value: "phase" },
        { text: this.$t('message.documents.headers.documentType'), value: "documentType" },
        { text: this.$t('message.documents.headers.supplierType'), value: "fileType" },
        { text: this.$t('message.documents.headers.relatedDoc'), value: "purchaseOrder" },
        { text: this.$t('message.documents.headers.comments'), value: "commentManual" },
        { text: this.$t('message.documents.headers.active'), value: "deleted" },
        { text: this.$t('message.documents.headers.uploadMethod'), value: "typeLoad" },
        { text: this.$t('message.documents.headers.company'), value: "clientRFC" },
        { text: this.$t('message.documents.headers.sapResponse'), value: "sapResponse", sortable: false },
        {
          text: this.$t('message.documents.headers.sapResponseDetails'),
          value: "sapResponseDetails",
          sortable: false,
          class: "sap-response-details-col",
        },
        {
          text: this.$t('message.documents.headers.accountingDocumentNo'),
          value: "accountingDocumentNumber",
          sortable: true,
        },
        {
          text: this.$t('message.documents.headers.documentNo'),
          value: "materialDocumentNumber",
          sortable: true,
          class: "document-no-col",
        },
      ];
    },
    updateDocumentTypes() {
      this.documentTypes = [
        { value: 1, name: this.$t('message.documents.documentTypes.invoice') },
        { value: 2, name: this.$t('message.documents.documentTypes.paymentComplement') },
      ];
      this.deleted = [
        { value: 0, name: this.$t('message.documents.messages.yes') },
        { value: 1, name: this.$t('message.documents.messages.no') },
      ];
    },
    getSupplierType(value) {
      let t = this.supplierTypes.find((x) => x.id == value);
      return t ? t.name : "";
    },
    getPhase(value) {
      if (value === null || value === undefined) {
        return ''; // En blanco cuando el estatus es exitoso
      }
      // Convertir a número para asegurar comparación correcta
      const phaseNum = Number(value);
      // Return only the number without "Fase" prefix
      return String(phaseNum);
    },
    getList: function (oldVal) {
      if (oldVal === undefined) oldVal = 0;

      let createdAtIni = this.search.createdAtIni
        ? this.search.createdAtIni
        : "notSent";
      let createdAtFin = this.search.createdAtFin
        ? this.search.createdAtFin
        : "notSent";
      let dateEvalIni = this.search.dateIni ? this.search.dateIni : "notSent";
      let dateEvalFin = this.search.dateFin ? this.search.dateFin : "notSent";
      let supplierEval = this.search.supplier
        ? this.search.supplier.businessName.replace("&", "=")
        : "notSent";
      let supplierTypeEval = this.search.supplierType
        ? this.search.supplierType.id
        : "notSent";
      let docTypeEval = this.search.documentType
        ? this.search.documentType.value
        : "notSent";
      let statusEval = this.search.status ? this.search.status.id : "notSent";
      let companyCodeEval = this.search.companyCode
        ? this.search.companyCode
        : "notSent";
      let purchaseOrder = this.search.purchaseOrder
        ? this.search.purchaseOrder
        : "notSent";
      let invoiceNum = this.search.noFactura
        ? this.search.noFactura
        : "notSent";
      let deleted = this.search.deleted;
      let orderBy = this.pagination.sortBy ? this.pagination.sortBy : "notSent";
      orderBy = orderBy == "supplier.businessName" ? "businessName" : orderBy;
      let desc =
        this.pagination.descending != null
          ? this.pagination.descending
            ? "DESC"
            : "ASC"
          : "notSent";
      let uuid = this.search.uuid ? this.search.uuid : "notSent";
      let remission = this.search.remission ? this.search.remission : 'notSent'
      const currentLocale = this.$i18n.locale || 'es';
      this.$http
        .get(
          `Documents/invoices?page=${oldVal}&size=${this.pagination.rowsPerPage}&supplier=${supplierEval}&supplierType=${supplierTypeEval}&docType=${docTypeEval}&status=${statusEval}&deleted=${deleted}&oc=${purchaseOrder}&companyC=${companyCodeEval}&invoiceNum=${invoiceNum}&createdIn=${createdAtIni}&createdFi=${createdAtFin}&dateIn=${dateEvalIni}&dateFi=${dateEvalFin}&order=${orderBy}&desc=${desc}&uuid=${uuid}&remission=${remission}&locale=${currentLocale}`
        )
        .then(
          (response) => {
            var list = response.data.documents;
            if (response.data.totalItems > 0) {
              this.list = list;
              this.source = list;
              this.loading = false;
            } else {
              this.list = [];
              this.source = [];
              this.loading = true;
              setTimeout(() => {
                this.loading = false;
              }, 500);
            }

            this.pagination.totalItems = response.data.totalItems;
          },
          (error) => {
            this.snackbar(this.t.messages.errorGetList);
          }
        );
    },
    getSuppliers: function () {
      this.$http
        .get("Suppliers/search", {
          params: { deleted: this.search.deleted.value },
        })
        .then(
          (response) => {
            var list = response.body;
            this.suppliers = list;
            if (this.deletedOld != this.search.deleted) {
              this.deletedOld = this.search.deleted.value;
              this.search.supplier = null;
            }

            this.searchOnTable();
          },
          (error) => {
            this.snackbar(this.t.messages.errorGetSuppliers);
          }
        );
    },
    getStatuses: function () {
      this.$http.get("Status/").then(
        (response) => {
          var list = response.body;
          this.status = list;
        },
        (error) => {
          this.snackbar(this.t.messages.errorGetStatuses);
        }
      );
    },
    getSupplierTypes: function () {
      this.$http.get("SupplierType").then(
        (response) => {
          var list = response.body;
          this.supplierTypes = list;
        },
        (error) => {
          this.snackbar(this.t.messages.errorGetSupplierTypes);
        }
      );
    },
    searchOnTable: function () {
      this.isSearchP = true;
      this.getList(this.pageAct - 1);
    },
    loadUuidList() {
      if (this.uuidQuerry !== null) {
        const uuid = String(this.uuidQuerry).toUpperCase();
        this.$http.get(`Documents/invoices/uuidList?uuid=${uuid}`).then(
          (response) => {
            var list = response.body;
            this.uuidList = list;
            this.uuidLoading = false;
          },
          (error) => {
            this.snackbar(this.t.messages.errorGetUuids);
          }
        );
      }
    },
    getListToCSV() {
      this.exportLoading = true;
      this.exportDialog = true;
      let createdAtIni = this.search.createdAtIni
        ? this.search.createdAtIni
        : "notSent";
      let createdAtFin = this.search.createdAtFin
        ? this.search.createdAtFin
        : "notSent";
      let dateEvalIni = this.search.dateIni ? this.search.dateIni : "notSent";
      let dateEvalFin = this.search.dateFin ? this.search.dateFin : "notSent";
      let supplierEval = this.search.supplier
        ? this.search.supplier.businessName.replace("&", "=")
        : "notSent";
      let supplierTypeEval = this.search.supplierType
        ? this.search.supplierType.id
        : "notSent";
      let docTypeEval = this.search.documentType
        ? this.search.documentType.value
        : "notSent";
      let statusEval = this.search.status ? this.search.status.id : "notSent";
      let companyCodeEval = this.search.companyCode
        ? this.search.companyCode
        : "notSent";
      let purchaseOrder = this.search.purchaseOrder
        ? this.search.purchaseOrder
        : "notSent";
      let invoiceNum = this.search.noFactura
        ? this.search.noFactura
        : "notSent";
      let uuid = this.search.uuid ? this.search.uuid : "notSent";
      let remission = this.search.remission ? this.search.remission : 'notSent'
      // Get current locale from i18n
      const currentLocale = this.$i18n.locale || 'es';
      this.$http
        .get(
          `Documents/exportToCSV?supplier=${supplierEval}&supplierType=${supplierTypeEval}&docType=${docTypeEval}&status=${statusEval}&oc=${purchaseOrder}&companyC=${companyCodeEval}&deleted=${this.search.deleted.value}&invoiceNum=${invoiceNum}&createdIn=${createdAtIni}&createdFi=${createdAtFin}&dateIn=${dateEvalIni}&dateFi=${dateEvalFin}&uuid=${uuid}&remission=${remission}&locale=${currentLocale}`
        )
        .then(
          (response) => {
            let blob = new Blob(["\ufeff", response.body], {
              type: "text/csv",
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            
            // Get filename from Content-Disposition header or use default
            let filename = "SWS Inbound file.csv"; // Default filename
            const contentDisposition = response.headers.get('Content-Disposition');
            if (contentDisposition) {
              const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
              if (filenameMatch && filenameMatch[1]) {
                filename = filenameMatch[1].replace(/['"]/g, '');
              }
            }
            
            link.download = filename;
            link.click();
          },
          (error) => {
            this.snackbar(this.$t('message.errors.exportCsvProcessing'));
            console.error(error);
          }
        )
        .finally(() => {
          this.exportLoading = false;
          this.exportDialog = false;
        });
    },
    shouldEdit(item, credentials) {
      if (!credentials.DocumentsUpdate) {
        return false;
      }

      const isNational = item.supplier.supplierType.id == 1;
      const isInternational = item.supplier.supplierType.id == 2;
      const status = item.status;

      if (isNational) {
        return this.isStatusNotFinal(status);
      }

      if (isInternational) {
        return status != 1 && status != 20;
      }
      return false;
    },
    enterListUuid() {
      if (String(this.uuidQuerry).toLowerCase() == "null") {
        this.uuidList = this.nullArray;
        this.search.uuid = "NULL";
        this.getList();
      }
    },
    updatePagination(newPage) {
      if (newPage && newPage !== this.pageAct) {
        this.pageAct = newPage;
        localStorage.pageAct = newPage;
        this.StoredPageAct = newPage;
      }
    },
  },
  mounted() {
    // Initialize locale from i18n
    this.currentLocale = this.$i18n.locale || 'es';
    this.updateHeadersLanguage();
    this.updateDocumentTypes();

    if (
      localStorage.pageAct !== undefined &&
      localStorage.pageAct !== "undefined" &&
      localStorage.pageAct !== null
    ) {
      this.StoredPageAct = Number(localStorage.pageAct);
    } else {
      localStorage.pageAct = 1;
      this.StoredPageAct = 1;
    }
    this.search.currentPage = this.pageAct;

    this.getSuppliers();
    this.getSupplierTypes();
    this.getStatuses();

    this.pageAct = this.StoredPageAct;
    this.search.currentPage = this.StoredPageAct;

    const hola = {
      createdAtIni: this.search.createdAtIni,
      createdAtFin: this.search.createdAtFin,
      dateIni: this.search.dateIni,
      dateFin: this.search.dateFin,
      supplier: this.search.supplier,
      documentType: this.search.documentType,
      supplierType: this.search.supplierType,
      deleted: this.search.deleted,
      status: this.search.status,
      noFactura: this.search.noFactura,
      purchaseOrder: this.search.purchaseOrder,
      rowsPP: this.search.rowsPP,
      currentPage: this.StoredPageAct,
      sortBy: this.search.sortBy,
      descending: this.search.descending,
    };
    this.search = this.loadFilters(hola);
    this.search.currentPage = this.StoredPageAct;

    this.deletedOld = this.search.deleted;
    this.pagination.sortBy = this.search.sortBy
      ? this.search.sortBy
      : "createdAt";
    this.pagination.descending =
      this.search.descending == null ? true : this.search.descending;
    this.pagination.rowsPerPage =
      this.search.rowsPP != undefined ? this.search.rowsPP : 10;
    this.pageAct =
      this.search.currentPage != undefined
        ? this.search.currentPage
        : this.StoredPageAct;
    this.isSearchC = this.pageAct > 1 ? true : false;
  },
  filters: {
    moment: function (date) {
      // Note: filters don't have access to $i18n, using default locale
      return moment(date).locale("es").format("LL");
    },
  },
  watch: {
    '$i18n.locale'(newLocale) {
      this.currentLocale = newLocale || 'es';
      this.updateHeadersLanguage();
      this.updateDocumentTypes();
    },
    search: {
      handler(value) {
        this.saveFilters(this.search);
      },
      deep: true,
      immediate: false,
    },
    pagination(newVal, oldVal) {
      if (newVal.sortBy == null) {
        newVal.descending = false;
        newVal.sortBy = oldVal.sortBy;
      }
      if (newVal.sortBy) {
        this.list = [];
        this.loading = true;
        this.search.descending = newVal.descending;
        this.search.sortBy = newVal.sortBy;
        this.saveFilters(this.search);
        this.searchOnTable();
      }
    },
    pageAct(newVal, oldVal) {
      this.search.rowsPP = this.pagination.rowsPerPage;
      this.search.currentPage = newVal;
      this.saveFilters(this.search);
      this.pageAct = newVal;
      localStorage.pageAct = newVal;
      if (!this.isSearchC) this.getList(newVal - 1);
      else this.isSearchC = false;
    },
    pages(newVal, oldVal) {
      if (this.pageAct > newVal) {
        this.search.currentPage = 1;
        this.pageAct = 1;
        this.StoredPageAct = 1;
      }
      this.search.rowsPP = this.pagination.rowsPerPage;
      this.saveFilters(this.search);
      this.getList(this.pageAct - 1);
    },
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    noDataUuid() {
      if (this.uuidLoading) return "Buscando...";
      if (!this.uuidQuerry || this.uuidQuerry.length < 5)
        return "Favor de introducir al menos 5 caracteres o NULL para filtrar vacíos";
      else return "No hay datos";
    },
    searchUuid: {
      get() {
        if (this.search.uuid) return this.search.uuid;
        return this.uuidQuerry;
      },

      set(searchInput) {
        if (searchInput == null) {
          this.search.uuid = null;
          this.getList();
        } else if (searchInput != this.uuidQuerry) {
          this.uuidQuerry = searchInput;
          if (String(this.uuidQuerry).length >= 5) {
            if (!this.uuidLoading) {
              this.uuidLoading = true;
              this.loadUuidList();
            }
          } else {
            this.uuidList = this.emptyArray;
          }
        }
      },
    },
  },
};
</script>
